import React from "react";

const Footer = () => {
  return (
    <div className="text-center w-full my-12">
      <p>
        &copy; 2024{" "}
        <a href="mailto:abdo.ibrahim411@gmail.com" className="text-main">
          Abdulrahman Ibrahim
        </a>
        . All Rights Reserved
      </p>
    </div>
  );
};

export default Footer;
